import { ElementType, FC } from "react";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import css from "@styled-system/css";

import Box from "../Box/Box";
import { BoxProps } from "../Box/box.type";

export interface BadgeProps extends BoxProps, PositionProps {
  /**
  Available variants: "positive" | "negative" | "neutral" | "warning"
   */
  variant: "positive" | "negative" | "neutral" | "warning";
  /**
  A label to be displayed
   */
  label: string;
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   The html tag to be used
   */
  as?: ElementType;
}

const badgeColor = {
  positive: "positive-background-color",
  negative: "negative-background-color",
  neutral: "neutral-background-color",
  warning: "warning-background-color",
};

const Container = styled(Box)<BadgeProps>`
  ${position}
  ${css({
    borderRadius: 1,
    fontFamily: "normal",
    lineHeight: "normal",
    fontWeight: "semiBold",
    fontSize: "body-small",
    "&.badge": {
      color: "text-color-over-background",
    },
  })}
`;

const Badge: FC<BadgeProps> = ({
  variant,
  label,
  as = "span",
  ...props
}: BadgeProps) => (
  <Container
    as={as}
    className="badge"
    backgroundColor={badgeColor[variant]}
    px={2}
    py={1}
    {...props}
  >
    {label}
  </Container>
);

export default Badge;
